<template>
    <div class="footer-container">
        <div class="foot-main">
            <div class="lists-box">
                <div class="list1">
                    <div class="title">太平洋西岸</div>
                        <ul>
                            <li v-for="(item, i) in areaList" :key="i" @click="checkArea(i)">{{item.name}}</li>
                        </ul>
                    <!-- <div class="list-view">
                    </div> -->
                </div>
                <div class="list1">
                    <div class="title">
                        {{areaName}}
                        <i class="icon iconfont icon-xiajiantou1"></i>
                    </div>
                    <div class="list-view">
                        <ul>
                            <li v-for="(item, i) in areaChildList" :key="i">{{item.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="list1">
                    <div class="title">产业集群联盟</div>
                    <div class="list-view">
                        <ul>
                            <li v-for="(item, i) in silkRoadList" :key="i" @click="checkBaseItem(i)">{{item.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="list1">
                    <div class="title">
                        {{baseName}}
                        <i class="icon iconfont icon-xiajiantou1"></i>
                    </div>
                    <div class="list-view">
                        <ul>
                            <li v-for="(item, i) in phenixList" :key="i">{{item.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="list2">
                    <div class="title">鳳凰社</div>
                    <ul>
                        <li v-for="(item, i) in productList" :key="i" :class="{boderno: i==productList.length - 1}">
                            <div class="img-box" @click="productShow(i)">
                                <img :src="item.imgUrl" alt="">
                            </div>
                            <div class="li-title">点击图片扫码进入小程序商城</div>
                        </li>
                    </ul>
                    <div class="pro-show-box" v-show="nowShowProduct">
                        <input type="text" ref="hiddenInput" @blur="productHidden()" style="">
                        <div class="img-box">
                            <img :src="nowShowProduct" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="about-box">
                <div class="item-box left-item">
                    <div class="txt1">湾潮</div>
                    <div class="txt2">WWW.BIGBAYS.CN</div>
                </div>
                <div class="item-box">
                    <div class="info">
                        北冥有鱼，其名为鲲。鲲之大，不知其几千里也；化而为鸟，其名为鹏。鹏之背，不知其几千里也；怒而飞，抟扶摇而上者九万里，其翼若垂天之云......
                    </div>
                </div>
                <div class="item-box">
                    <div class="er-wei-ma">
                        <a class="code" href="http://sztv.cutv.com/" target="_blank">
                            <div class="img-box">
                                <img src="https://cdn.bigbays.cn/pc/home/yishenzhen2x.png" alt="">
                            </div>
                            <p>壹深圳</p>
                        </a>
                        <a class="code" href="https://www.ifeng.com/" target="_blank">
                            <div class="img-box">
                                <img src="https://cdn.bigbays.cn/pc/home/fenghuangwang2x.png" alt="">
                            </div>
                            <p>凤凰网</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="foot-info">
                <div class="info-item-l">
                    <span>凤凰社&nbsp;</span>
                    <div>
                        <img src="https://cdn.bigbays.cn/pc/home/fenghuangshe-logo2x.png" alt="">
                    </div>
                    <span>
                        &nbsp;版权所有
                        &nbsp;&nbsp;Copyright©凤凰社 All Rights Reserved
                        &nbsp;&nbsp;苍穹云系统提供技术支持
                    </span>
                </div>
                <div class="info-item-r"><a class="code" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备19079008号-2</a></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FooterComponent',
    data() {
        return {
            areaList: [
                {
                    name: '东京湾',
                    children: [
                        { name: '东京市' },
                        { name: '横滨市' },
                        { name: '川崎市' },
                        { name: '千叶市' },
                        { name: '船桥市' },
                        { name: '琦玉市' }
                    ]
                },
                {
                    name: '渤海湾',
                    children: [
                        { name: '北京市' },
                        { name: '天津市' },
                        { name: '沈阳市' },
                        { name: '石家庄' },
                        { name: '济南市' },
                        { name: '青岛市' },
                        { name: '大连市' },
                        { name: '秦皇岛市' },
                        { name: '雄安新区' }
                    ]
                },
                {
                    name: '长三角',
                    children: [
                        { name: '上海市' },
                        { name: '南京市' },
                        { name: '杭州市' },
                        { name: '无锡市' },
                        { name: '常州市' },
                        { name: '苏州市' },
                        { name: '南通市' },
                        { name: '扬州市' },
                        { name: '镇江市' },
                        { name: '宁波市' }
                    ]
                },
                {
                    name: '海西',
                    children: [
                        { name: '福州市' },
                        { name: '泉州市' },
                        { name: '厦门市' },
                        { name: '温州市' },
                        { name: '汕头市' }
                    ]
                },
                {
                    name: '粤港澳大湾区',
                    children: [
                        { name: '广州' },
                        { name: '深圳' },
                        { name: '东莞' },
                        { name: '珠海' },
                        { name: '佛山' },
                        { name: '中山' },
                        { name: '江门' },
                        { name: '惠州' },
                        { name: '肇庆' },
                        { name: '香港' },
                        { name: '澳门' }
                    ]
                },
                {
                    name: '北部湾',
                    children: [
                        { name: '南宁市' },
                        { name: '北海市' },
                        { name: '钦州市' },
                        { name: '防城港市' },
                        { name: '玉林市' },
                        { name: '崇左市' },
                        { name: '湛江市' },
                        { name: '阳江市' },
                        { name: '茂名市' }
                    ]
                },
                {
                    name: '东盟十国',
                    children: [
                        { name: '文莱' },
                        { name: '柬埔寨' },
                        { name: '印度尼西亚' },
                        { name: '老挝' },
                        { name: '马来西亚' },
                        { name: '缅甸' },
                        { name: '菲律宾' },
                        { name: '新加坡' },
                        { name: '泰国' },
                        { name: '越南' }
                    ]
                },
                {
                    name: '台湾',
                    children: [
                        { name: '台北市' },
                        { name: '新北市' },
                        { name: '桃园市' },
                        { name: '台中市' },
                        { name: '台南市' },
                        { name: '高雄市' },
                        { name: '基隆市' },
                        { name: '新竹市' },
                        { name: '嘉义市' }
                    ]
                },
                {
                    name: '香港',
                    children: [
                        { name: '中西区' },
                        { name: '湾仔区' },
                        { name: '东区' },
                        { name: '南区' },
                        { name: '油尖旺区' },
                        { name: '深水埗区' },
                        { name: '九龙城区' },
                        { name: '黄大仙区' },
                        { name: '观塘区' },
                        { name: '北区' },
                        { name: '大埔区' },
                        { name: '沙田区' },
                        { name: '西贡区' },
                        { name: '荃湾区' },
                        { name: '屯门区' },
                        { name: '元朗区' },
                        { name: '葵青区' },
                        { name: '离岛区' }
                    ]
                },
                {
                    name: '澳门',
                    children: [
                        { name: '花地玛堂区' },
                        { name: '圣安多尼堂区' },
                        { name: '大堂区' },
                        { name: '望德堂区' },
                        { name: '风顺堂区' },
                        { name: '嘉模堂区' },
                        { name: '圣方济各堂区' }
                    ]
                },
                {
                    name: '广州',
                    children: [
                        { name: '荔湾区' },
                        { name: '越秀区' },
                        { name: '海珠区' },
                        { name: '天河区' },
                        { name: '白云区' },
                        { name: '黄浦区' },
                        { name: '番禺区' },
                        { name: '花都区' },
                        { name: '南沙区' },
                        { name: '从化区' },
                        { name: '增城区' }
                    ]
                },
                {
                    name: '深圳',
                    children: [
                        { name: '福田区' },
                        { name: '南山区' },
                        { name: '宝安区' },
                        { name: '光明区' },
                        { name: '龙华区' },
                        { name: '龙岗区' },
                        { name: '坪山区' },
                        { name: '大鹏区' },
                        { name: '盐田区' },
                        { name: '罗湖区' }
                    ]
                },
                {
                    name: '海南',
                    children: [
                        {name: '海口市'},
                        {name: '三亚市'},
                        {name: '儋州市'},
                        {name: '三沙市'},
                        {name: '东方市'}
                    ]
                }
            ],
            areaName: '深圳',
            areaChildList: [],
            silkRoadList: [
                { name: '新农业', children: [
                    {name: '现代农业'},
                    {name: '农产品流通'},
                    {name: '未来农业'},
                    {name: '智慧农业'}
                ] },
                { name: '新消费', children: [
                    {name: '时尚家居'},
                    {name: '智能家居'},
                    {name: '会展'},
                    {name: '智能手机'},
                    {name: '智能终端'},
                    {name: '消费电子'},
                    {name: '教育'},
                    {name: '体育科技'},
                    {name: '影视传媒'},
                    {name: '电子竞技'},
                    {name: '科技文旅'},
                    {name: '新零售'},
                    {name: '消费金融'},
                    {name: '电子商务'},
                ] },
                { name: '生命健康', children: [
                    {name: '生物制品'},
                    {name: '生物医药'},
                    {name: '中医药'},
                    {name: '医疗器械'},
                    {name: '大健康'}
                ] },
                { name: '绿色经济', children: [
                    {name: '节能环保'},
                    {name: '绿色建筑'},
                    {name: '垃圾分类'},
                    {name: '清洁生产'},
                    {name: '电力装备'},
                    {name: '新能源'},
                    {name: '新能源汽车'},
                    {name: '合同能源管理'}
                ] },
                { name: '海洋经济', children: [
                    {name: '海洋商事'},
                    {name: '海洋资源'},
                    {name: '海产品'},
                    {name: '海洋医药'},
                    {name: '海洋科技'},
                    {name: '海洋娱乐'}
                ] },
                { name: '现代物流', children: [
                    {name: '先进包装'},
                    {name: '智能仓储'},
                    {name: '物流园'},
                    {name: '智能配送'},
                    {name: '冷链物流'},
                    {name: '特种物流'},
                    {name: '港口物流'}
                ] },
                { name: '化工材料', children: [
                    {name: '有机高分子材料'},
                    {name: '先进复合材料'},
                    {name: '金属材料'},
                    {name: '表面处理'},
                    {name: '精细化工'},
                    {name: '汽车新材料'},
                    {name: '前沿材料'},
                    {name: '无机非金属材料'}
                ] },
                { name: '人工智能', children: [
                    {name: '感知设备'},
                    {name: '工业互联网'},
                    {name: '3D打印'},
                    {name: '智慧城市'},
                    {name: '数字金融'},
                    {name: '智能穿戴'},
                    {name: '智能制造'}
                ] },
                { name: '高端装备制造', children: [
                    {name: '机器人'},
                    {name: '航空航天'},
                    {name: '海洋工程装备'},
                    {name: '军工'},
                    {name: '无人机'},
                    {name: '卫星产业'}
                ] },
                { name: '新一代信息技术', children: [
                    {name: '集成电路'},
                    {name: '光器件'},
                    {name: '新型显示'},
                    {name: '计算机'},
                    {name: '软件'},
                    {name: '大数据'},
                    {name: '网络安全'},
                    {name: '物联网'},
                    {name: '区块链'},
                    {name: '5G'},
                    {name: '下一代通信网络'}
                ] }
            ],
            baseName: '新消费',
            phenixList: [
                {name: '时尚家居'},
                    {name: '智能家居'},
                    {name: '会展'},
                    {name: '智能手机'},
                    {name: '智能终端'},
                    {name: '消费电子'},
                    {name: '教育'},
                    {name: '体育科技'},
                    {name: '影视传媒'},
                    {name: '电子竞技'},
                    {name: '科技文旅'},
                    {name: '新零售'},
                    {name: '消费金融'},
                    {name: '电子商务'},
            ],
            productList: [
                {
                    imgUrl: 'https://cdn.bigbays.cn/pc/home/product1.jpg'
                },
                {
                    imgUrl: 'https://cdn.bigbays.cn/pc/home/product2.jpg'
                },
                {
                    imgUrl: 'https://cdn.bigbays.cn/pc/home/product3.jpg'
                }
            ],
            nowShowProduct: ''
        }
    },
    mounted() {
        this.checkArea(11);
        
    },
    methods: {
        checkArea(i) {
            this.areaName = this.areaList[i].name;
            this.areaChildList = this.areaList[i].children;
        },
        checkBaseItem(i) {
            this.baseName = this.silkRoadList[i].name;
            this.phenixList = this.silkRoadList[i].children;
        },
        /**
         * @function productShow 商品展示
         */
        productShow(i) {
            setTimeout(() => {
                this.$nextTick((x)=>{
                    this.$refs.hiddenInput.focus();
                });
            }, 0);
            this.nowShowProduct = this.productList[i].imgUrl;
        },
        /**
         * @function productHidden 隐藏商品展示图
         */
        productHidden() {
            this.nowShowProduct = '';
        }
    }
}
</script>
<style lang="scss" scoped>
@import './FooterComponent.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/footer/FooterComponent.vue